import {
  Auth,
  Moment,
 } from '@intelipost-js/secure-providers';

class Session {
  static securityInfos() {
    const userSettings = Auth.getUser();
    const { security } = userSettings;
    const {
      token_timeout_inactivity = null,
      session_start,
    } = security || {};

    return {
      token_timeout_inactivity,
      session_start,
    };
  }
  static timeDiff() {
    const currentTime = Moment();

    return currentTime.diff(Moment(Session.securityInfos().session_start), 'minutes');
  }

  static checkSessionTime() {
    if (Session.timeDiff() > Session.securityInfos().token_timeout_inactivity) {
      window.logout();
      const host = window.location.origin;
      window.location.replace(`${host}/login`);
    }
  }

  static RegisterEvents() {
    document.addEventListener('DOMContentLoaded', () => new Promise(() => {
      setTimeout(() => {
        const buttons = [...document.querySelectorAll('button')];
        const as = [...document.querySelectorAll('a')];
        const mergeArraylements = [].concat(buttons, as);

        mergeArraylements.map(e => e.addEventListener('click', Session.checkSessionTime));
      }, 3000);
    }));
  }
}

export default new Session.RegisterEvents();



// WEBPACK FOOTER //
// ./src/session.js